import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ResonanceShifter from "@/pages/ResonanceShifter";
import EntrainmentLayer from "@/pages/EntrainmentLayer";
import BinauralBrain from "@/components/BinauralBrain";

export default function ResonanceHub() {
  return (
    <div className="w-full">
      <div className="mx-auto max-w-6xl px-3 sm:px-6 py-4">
        <Tabs defaultValue="binuaral" className="w-full" data-testid="resonance-hub-tabs">
          <TabsList className="bg-black/60 border border-[#FF0000]/30">
            <TabsTrigger value="binuaral" className="data-[state=active]:text-[#FF0000] text-[#FF0000]/50 text-xs tracking-widest font-mono">
              Bi-Nuaral
            </TabsTrigger>
            <TabsTrigger value="resonance" className="data-[state=active]:text-[#FF0000] text-[#FF0000]/50 text-xs tracking-widest font-mono">
              Resonance
            </TabsTrigger>
            <TabsTrigger value="entrainment" className="data-[state=active]:text-[#FF0000] text-[#FF0000]/50 text-xs tracking-widest font-mono">
              Entrainment
            </TabsTrigger>
          </TabsList>

          <TabsContent value="binuaral" className="mt-4">
            <BinauralBrain />
          </TabsContent>

          <TabsContent value="resonance" className="mt-4">
            <ResonanceShifter />
          </TabsContent>

          <TabsContent value="entrainment" className="mt-4">
            <EntrainmentLayer />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
